import { render, staticRenderFns } from "./GitlabAccountModal.vue?vue&type=template&id=2817d0fb&"
import script from "./GitlabAccountModal.vue?vue&type=script&lang=js&"
export * from "./GitlabAccountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GitlabAccountModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GitlabAccountModal.vue
// module id = 2365
// module chunks = 1